import { memo, Suspense, useCallback, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAlert } from "../../contexts/alertContext";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import MuiSnackbar from "../../components/UI/MuiSnackbar/MuiSnackbar";
import React from "react";
import useApp from "../../hooks/useApp";
import { LocalStorage } from "../../enums/localStorage";
import useLoading from "../../hooks/loading";
import ActionLoader from "../../components/UI/ActionLoader/ActionLoader";
import Listing from "../Listing/Listing";
import Header from "../../components/Header/Header";
import SideMenu from "../../components/SideMenu";

const Dashboard: React.FC = () => {
  const { alert } = useAlert();
  const { i18n } = useTranslation();
  const { pathname, search } = useLocation();
  const { push } = useApp();
  const { loading, setLoading } = useLoading();

  const redirectToLogin = (): void => {
    setLoading(false);
    localStorage.removeItem(LocalStorage.ACCESS_TOKEN);
    localStorage.removeItem(LocalStorage.REFRESH_TOKEN);

    push("/login");
  };

  const initApp = useCallback(async () => {
    try {
      setLoading(false);

      push(search.length === 0 ? pathname : pathname + search);
    } catch (err: Error | any) {
      redirectToLogin();
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const accessToken: string | null = localStorage.getItem(
      LocalStorage.ACCESS_TOKEN
    );
    if (accessToken) initApp();
    else redirectToLogin();

    // eslint-disable-next-line
  }, []);

  if (loading) return <ActionLoader position="fixed" />;
  return (
    <Stack
      component="main"
      direction={"row"}
      bgcolor="background.default"
      width={"100dvw"}
      height={"100dvh"}
      useFlexGap
    >
      <Suspense fallback={<ActionLoader position="fixed" />}>
        <SideMenu />
        <Stack
          width={1}
          height={1}
          p={2}
          minHeight={"100vh"}
          flexGrow={1}
          sx={{ overflowY: "auto" }}
        >
          <Header />
          <Suspense fallback={<ActionLoader position="fixed" />}>
            <Routes>
              <Route path="/*" element={<Navigate to={"/plans"} />} />
              <Route path=":slug/*" element={<Listing />} />
            </Routes>
          </Suspense>
        </Stack>
      </Suspense>
      <MuiSnackbar alert={alert!} />
    </Stack>
  );
};

export default memo(Dashboard);
